import {createSlice} from '@reduxjs/toolkit';
import { getUserInfo } from './thunk';

export const initialState = {
    userInfo: "",
    error: {},
};

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUserInfo.fulfilled, (state, action) => {
            state.userInfo = action.payload;
        });
        builder.addCase(getUserInfo.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });
    }
});

export default userInfoSlice.reducer;